/**
 * Subaccounts (in-app, Hyperliquid-style).
 *
 * A subaccount is a fresh browser-held keypair that the master wallet links on-chain with two-sided
 * consent (master signs AddSubaccount, the generated sub key signs LinkSubaccount), so the master —
 * or the master's one-click agent — can trade it. Linking is submitted gaslessly by the relayer.
 *
 * Collateral is moved between master and subaccount via gasless INTERNAL transfers
 * (CLOBEngine.transferBySignature): a pure ledger move, no ERC-20 leaves the engine and no fee.
 *   - Fund (master → sub): the MASTER wallet signs (funds movement is always owner-signed, never an
 *     agent — a leaked session key can trade but can never move funds).
 *   - Defund (sub → master): the app-held SUB key signs silently (it moves its own balance, and only
 *     ever back to its master).
 *
 * Unlink is an on-chain wallet tx (there is no by-signature unlink on-chain); either party may call it.
 *
 * Storage: sub keypairs live in localStorage keyed by chainId+master. The private keys are TRADE/FUND
 * scoped to the master relationship — a sub can only send its balance back to its own master.
 *
 * This module is a thin shell; implementation lives in the sibling files below.
 */
export type {
  SubaccountAuthInfo,
  StoredSubaccount,
  SubaccountView,
} from "./subaccounts.types";

export {
  listSubaccounts,
  getSubaccountWallet,
  removeSubaccountLocal,
} from "./subaccounts.storage";

export {
  createSubaccount,
  fundSubaccount,
  defundSubaccount,
  unlinkSubaccount,
  registerSubaccountApiKey,
} from "./subaccounts.actions";
